import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GalleryDto, GalleryStatus } from '@picflow/types';
import { GalleryStatusButtonColorPipe } from '../../pipes/gallery-status-button-color.pipe';
import { GalleryStatusColorPipe } from '../../pipes/gallery-status-color.pipe';
import { GalleryStatusIconPipe } from '../../pipes/gallery-status-icon.pipe';
import { GalleryStatusNamePipe } from '../../pipes/gallery-status-name.pipe';
import { ButtonMenuItemComponent } from '../../shared/components/button-menu-item/button-menu-item.component';
import { SvgComponent } from '../../shared/components/svg/svg.component';
import { GalleryStatusOrderPipe } from '../../shared/pipes/gallery-status-order.pipe';

@Component({
  selector: 'app-gallery-status-context',
  standalone: true,
  templateUrl: './gallery-status-context.component.html',
  styleUrls: ['./gallery-status-context.component.scss'],
  imports: [
    CommonModule,
    ButtonMenuItemComponent,
    SvgComponent,
    GalleryStatusNamePipe,
    GalleryStatusColorPipe,
    GalleryStatusButtonColorPipe,
    GalleryStatusIconPipe,
    GalleryStatusOrderPipe,
  ],
})
export class GalleryStatusContextComponent {
  @Input({ required: true }) gallery: GalleryDto;
  @Output() onSelectStatus = new EventEmitter<GalleryStatus>();
}
